import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArticleHeroSection } from '@marketing/components/sections/heroes/HeroSection/HeroSection';
import ContactSection from '@marketing/components/sections/non_product/Contact';
import Newsletter from '@marketing/components/sections/non_product/Newsletter';
import RelatedArticles from '@marketing/components/sections/non_product/RelatedArticles';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Skeleton from 'react-loading-skeleton';
import { useLocation, useNavigate, useParams, useRouteLoaderData } from 'react-router';
var Article = function () {
    var _a, _b;
    var params = useParams();
    var location = useLocation();
    var navigate = useNavigate();
    var Butter = useRouteLoaderData('root').Butter;
    var _c = useState(null), article = _c[0], setArticle = _c[1];
    var _d = useState((_a = location.state) === null || _a === void 0 ? void 0 : _a.category), category = _d[0], setCategory = _d[1];
    var _e = useState((_b = location.state) === null || _b === void 0 ? void 0 : _b.categorySlug), categorySlug = _e[0], setCategorySlug = _e[1];
    useEffect(function () {
        Butter.page
            .retrieve('article', params.articleSlug, { alt_media_text: 1 })
            .then(function (response) {
            if (response.data) {
                setArticle(response.data.data);
                var categories = response.data.data.fields.article_categories;
                if (categories.length > 0) {
                    var articleCategory = categories[0];
                    setCategory(articleCategory.category_name);
                    setCategorySlug(articleCategory.api_slug);
                }
                else {
                    setCategory(null);
                    setCategorySlug(null);
                }
            }
            else {
                console.error('Error fetching article:', response);
            }
        })
            .catch(function (error) {
            console.error('Error fetching article:', error);
            navigate('/404', { viewTransition: true });
        });
    }, [params.articleSlug]);
    var breadcrumbs = [{ label: 'Blog', href: '/learn' }];
    if (!!category && !!categorySlug) {
        breadcrumbs.push({
            label: category,
            href: "/learn/category/".concat(categorySlug),
        });
    }
    return (_jsx("div", { children: article ? (_jsxs(_Fragment, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: article.fields.title }), _jsx("meta", { name: "description", content: article.fields.description }), _jsx("meta", { name: "og:title", content: article.fields.og_title }), _jsx("meta", { name: "og:description", content: article.fields.og_description }), _jsx("meta", { name: "og:image", content: article.fields.og_image.url })] }), _jsx(ArticleHeroSection, { breadcrumbs: breadcrumbs, headline: article.fields.h1, subhead: article.fields.summary, imageData: {
                        src: article.fields.hero_image.url,
                        alt: article.fields.hero_image.alt,
                        height: 380,
                        width: 498,
                    } }), _jsx("div", { className: "article mx-4 max-w-full md:max-w-md md:mx-auto py-8 md:py-20", dangerouslySetInnerHTML: { __html: article.fields.content } }), article.fields.related_guides.some(function (article) { return !!article; }) && (_jsx(RelatedArticles, { content: { relatedArticles: article.fields.related_guides } })), _jsx(ContactSection, { content: {
                        title: 'Try Nom Nom',
                        subheading: "There are so many benefits to being a Nom Nom subscriber,\n              including plans personalized to your Dog\u2019s unique nutritional needs\n              and delivered directly to your door.",
                        buttonLabel: 'Get Started',
                        ctaUrl: '/profile',
                    }, backgroundColor: "squash" }), _jsx(Newsletter, { flip: true })] })) : (_jsx(Skeleton, { count: 5 })) }));
};
export default Article;
